import _typeof from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/typeof.js";
import _objectWithoutProperties from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _toConsumableArray from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { create } from "zustand";
import { devtools } from "zustand/middleware";
import { ChangeMode } from "./types";
function recomputeEditingMode(patientTags) {
  return Object.values(patientTags).some(function (tag) {
    return tag.changeMode !== undefined;
  });
}

/** Global staged-edit store for patient custom tags. */
export var usePatientTagsStore = create()(devtools(function (set) {
  return {
    patientTags: {},
    order: [],
    isEditingMode: false,
    isExpanded: false,
    serverTags: [],
    setExpanded: function setExpanded(expanded) {
      return set({
        isExpanded: expanded
      }, false, "setExpanded");
    },
    setServerTags: function setServerTags(tags) {
      return set({
        serverTags: tags
      }, false, "setServerTags");
    },
    addTag: function addTag(tagId, item) {
      return set(function (state) {
        return {
          isEditingMode: true,
          patientTags: _objectSpread(_objectSpread({}, state.patientTags), {}, _defineProperty({}, tagId, item)),
          order: state.order.includes(tagId) ? state.order : [].concat(_toConsumableArray(state.order), [tagId])
        };
      }, false, "addTag");
    },
    editTag: function editTag(tagId, value, changeMode) {
      return set(function (state) {
        var _state$patientTags$ta;
        var existing = (_state$patientTags$ta = state.patientTags[tagId]) === null || _state$patientTags$ta === void 0 ? void 0 : _state$patientTags$ta.changeMode;
        var resolvedMode = existing === ChangeMode.ADD ? ChangeMode.ADD : changeMode;
        var patientTags = _objectSpread(_objectSpread({}, state.patientTags), {}, _defineProperty({}, tagId, _objectSpread(_objectSpread({}, state.patientTags[tagId]), {}, {
          value: value,
          changeMode: resolvedMode
        })));
        return {
          patientTags: patientTags,
          isEditingMode: recomputeEditingMode(patientTags)
        };
      }, false, "editTag");
    },
    deleteTag: function deleteTag(tagId) {
      return set(function (state) {
        var _state$patientTags$ta2;
        var isNew = ((_state$patientTags$ta2 = state.patientTags[tagId]) === null || _state$patientTags$ta2 === void 0 ? void 0 : _state$patientTags$ta2.changeMode) === ChangeMode.ADD;
        if (isNew) {
          var _state$patientTags = state.patientTags,
            _removed = _state$patientTags[tagId],
            rest = _objectWithoutProperties(_state$patientTags, [tagId].map(_toPropertyKey));
          return {
            patientTags: rest,
            order: state.order.filter(function (id) {
              return id !== tagId;
            }),
            isEditingMode: recomputeEditingMode(rest)
          };
        }
        var patientTags = _objectSpread(_objectSpread({}, state.patientTags), {}, _defineProperty({}, tagId, _objectSpread(_objectSpread({}, state.patientTags[tagId]), {}, {
          changeMode: ChangeMode.DELETE
        })));
        return {
          patientTags: patientTags,
          isEditingMode: recomputeEditingMode(patientTags)
        };
      }, false, "deleteTag");
    },
    revertTag: function revertTag(tagId, originalValue) {
      return set(function (state) {
        var patientTags = _objectSpread(_objectSpread({}, state.patientTags), {}, _defineProperty({}, tagId, _objectSpread(_objectSpread({}, state.patientTags[tagId]), {}, {
          value: originalValue,
          changeMode: undefined
        })));
        return {
          patientTags: patientTags,
          isEditingMode: recomputeEditingMode(patientTags)
        };
      }, false, "revertTag");
    },
    resetTags: function resetTags(patientTags, order) {
      return set({
        patientTags: patientTags,
        order: order,
        isEditingMode: false
      }, false, "resetTags");
    }
  };
}, {
  name: "PatientTagsStore",
  enabled: typeof window !== "undefined" && process.env.NODE_ENV !== "production"
}));